import { Navigate } from "react-router-dom";
import { firstMarketplacePath } from "../../config/navigation";
import { useAuth } from "../../stores/auth";

export function MarketplaceIndexRedirect() {
  const { can, moduleEnabled } = useAuth();
  const path = firstMarketplacePath(can, moduleEnabled);
  if (!path) return <Navigate to="/" replace />;
  return <Navigate to={path} replace />;
}
